import jquery from "./jquery.min.js";

export default (window.$ = window.jQuery = jquery);
